import React from 'react';
import FaqCard from './FaqCard/FaqCard';

const faqPosts = [
    {
        title: 'Do you offer onsite repairs?',
        content: 'Yes. We offer a onsite or in home service for repair. Extra charges may apply.'
    },
    {
        title: 'Do you recycle old computers and parts?',
        content: 'Yes. Please feel free to bring your old electronic in so they will be recycled properly.'
    },
    {
        title: 'What if I live out of the San Diego region?',
        content: 'Feel free to ship us your laptop. There will be a small charge for return shipping.'
    }
]

const Faq = () => {
    return (
        <div className="mt-5 text-center p-5" id="faq" style={{ background: '#F4F7FC'}}>
            <h1 className="text-color"><b>FAQ</b></h1>
            <div className="row d-flex justify-content-center">
                {
                    faqPosts.map(post => <FaqCard post={post}/>)
                }
            </div>
        </div>
    );
};

export default Faq;